export default __webpack_public_path__ + "static/media/check.e2073c1a.svg";